/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type BUDGET_TYPE = "FIXED_PRICE" | "FIXED_PRICE_V2" | "NON_BILLABLE" | "RETAINER" | "TIME_AND_MATERIALS" | "%future added value";
export type PERIODICITY = "DAILY" | "MONTHLY" | "WEEKLY" | "%future added value";
export type PERIOD_BUDGET_TYPE = "FIXED_HOURS" | "FIXED_PRICE" | "TIME_AND_MATERIALS" | "%future added value";
export type PROJECT_STATUS = "DONE" | "HALTED" | "OPPORTUNITY" | "PLANNING" | "RUNNING" | "%future added value";
export type CreateProjectInput = {
    name?: string | null | undefined;
    projectColor?: string | null | undefined;
    customProjectId?: string | null | undefined;
    labels?: Array<string | null> | null | undefined;
    sprintTimeBox?: boolean | null | undefined;
    sprintLengthInDays?: number | null | undefined;
    projectStartDay?: number | null | undefined;
    projectStartMonth?: number | null | undefined;
    projectStartYear?: number | null | undefined;
    projectEndDay?: number | null | undefined;
    projectEndMonth?: number | null | undefined;
    projectEndYear?: number | null | undefined;
    rateCardId?: string | null | undefined;
    statusColumns?: Array<StatusColumnInput | null> | null | undefined;
    useManualAllocations?: boolean | null | undefined;
    useBaseline?: boolean | null | undefined;
    synchBaselineAndScopingDates?: boolean | null | undefined;
    useFixedPriceForBaselineRevenue?: boolean | null | undefined;
    budgetType?: BUDGET_TYPE | null | undefined;
    clientId?: string | null | undefined;
    budget?: number | null | undefined;
    defaultPeriodPriceAmount?: number | null | undefined;
    defaultPeriodHoursAmount?: number | null | undefined;
    defaultPeriodBudgetType?: PERIOD_BUDGET_TYPE | null | undefined;
    defaultPeriodLength?: number | null | undefined;
    defaultPeriodPeriodicity?: PERIODICITY | null | undefined;
    defaultPeriodSettingIgnoreForBilling?: boolean | null | undefined;
    defaultPeriodSettingSubtractValue?: boolean | null | undefined;
    defaultPeriodSettingRollValue?: boolean | null | undefined;
    defaultPeriodSettingAddExpenses?: boolean | null | undefined;
    estimationUnit?: string | null | undefined;
    remainingAutoCalculated?: boolean | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type StatusColumnInput = {
    id?: string | null | undefined;
    name?: string | null | undefined;
    order?: number | null | undefined;
    category?: string | null | undefined;
    projectId?: string | null | undefined;
    projectGroupStatusColumnId?: number | null | undefined;
    autoShowOnTimePage?: boolean | null | undefined;
    encourageTimeRegistration?: boolean | null | undefined;
};
export type createProjectMutationVariables = {
    input: CreateProjectInput;
};
export type createProjectMutationResponse = {
    readonly createProject: {
        readonly errors: ReadonlyArray<string | null> | null;
        readonly project: {
            readonly node: {
                readonly projectPersons: {
                    readonly edges: ReadonlyArray<{
                        readonly node: {
                            readonly id: string;
                            readonly isContactPerson: boolean | null;
                            readonly person: {
                                readonly id: string;
                                readonly firstName: string | null;
                                readonly lastName: string | null;
                                readonly profilePictureId: string | null;
                            } | null;
                        } | null;
                    } | null> | null;
                } | null;
                readonly id: string;
                readonly companyProjectId: number | null;
                readonly customProjectId: string | null;
                readonly status: PROJECT_STATUS | null;
                readonly name: string | null;
                readonly isJiraProject: boolean | null;
                readonly projectColor: string | null;
                readonly fullAccessToProject: boolean | null;
                readonly readOnlyAccess: boolean | null;
                readonly isInProjectGroup: boolean | null;
                readonly billable: boolean | null;
                readonly budgetType: BUDGET_TYPE | null;
                readonly projectGroupId: string | null;
                readonly sprintTimeBox: boolean | null;
                readonly useBaseline: boolean | null;
                readonly harvestProject: {
                    readonly id: string;
                } | null;
                readonly statusColumnsV2: {
                    readonly edges: ReadonlyArray<{
                        readonly node: {
                            readonly id: string;
                            readonly projectGroupStatusColumnId: number | null;
                        } | null;
                    } | null> | null;
                } | null;
                readonly priorityLevel: {
                    readonly id: string;
                    readonly name: string | null;
                    readonly weight: number | null;
                } | null;
            } | null;
        } | null;
    } | null;
};
export type createProjectMutation = {
    readonly response: createProjectMutationResponse;
    readonly variables: createProjectMutationVariables;
};



/*
mutation createProjectMutation(
  $input: CreateProjectInput!
) {
  createProject(input: $input) {
    errors
    project {
      node {
        projectPersons(first: 1000000, contactsOnly: true) {
          edges {
            node {
              id
              isContactPerson
              person {
                id
                firstName
                lastName
                profilePictureId
              }
            }
          }
        }
        id
        companyProjectId
        customProjectId
        status
        name
        isJiraProject
        projectColor
        fullAccessToProject
        readOnlyAccess
        isInProjectGroup
        billable
        budgetType
        projectGroupId
        sprintTimeBox
        useBaseline
        harvestProject {
          id
        }
        statusColumnsV2(first: 1000000) {
          edges {
            node {
              id
              projectGroupStatusColumnId
            }
          }
        }
        priorityLevel {
          id
          name
          weight
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateProjectInput!"
  }
],
v1 = {
  "kind": "Literal",
  "name": "first",
  "value": 1000000
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateProjectPayload",
    "kind": "LinkedField",
    "name": "createProject",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectTypeEdge",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "contactsOnly",
                    "value": true
                  },
                  (v1/*: any*/)
                ],
                "concreteType": "ProjectPersonTypeConnection",
                "kind": "LinkedField",
                "name": "projectPersons",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectPersonTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectPerson",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isContactPerson",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "person",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "firstName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lastName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "profilePictureId",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "projectPersons(contactsOnly:true,first:1000000)"
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "companyProjectId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customProjectId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isJiraProject",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fullAccessToProject",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "readOnlyAccess",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isInProjectGroup",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "billable",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "budgetType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sprintTimeBox",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useBaseline",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "HarvestProjectType",
                "kind": "LinkedField",
                "name": "harvestProject",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v1/*: any*/)
                ],
                "concreteType": "StatusColumnV2TypeConnection",
                "kind": "LinkedField",
                "name": "statusColumnsV2",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StatusColumnV2TypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StatusColumnV2",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "projectGroupStatusColumnId",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "statusColumnsV2(first:1000000)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PriorityLevel",
                "kind": "LinkedField",
                "name": "priorityLevel",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "weight",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createProjectMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createProjectMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createProjectMutation",
    "operationKind": "mutation",
    "text": "mutation createProjectMutation(\n  $input: CreateProjectInput!\n) {\n  createProject(input: $input) {\n    errors\n    project {\n      node {\n        projectPersons(first: 1000000, contactsOnly: true) {\n          edges {\n            node {\n              id\n              isContactPerson\n              person {\n                id\n                firstName\n                lastName\n                profilePictureId\n              }\n            }\n          }\n        }\n        id\n        companyProjectId\n        customProjectId\n        status\n        name\n        isJiraProject\n        projectColor\n        fullAccessToProject\n        readOnlyAccess\n        isInProjectGroup\n        billable\n        budgetType\n        projectGroupId\n        sprintTimeBox\n        useBaseline\n        harvestProject {\n          id\n        }\n        statusColumnsV2(first: 1000000) {\n          edges {\n            node {\n              id\n              projectGroupStatusColumnId\n            }\n          }\n        }\n        priorityLevel {\n          id\n          name\n          weight\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '8a3395fec86b5b8f4726f373b558b8e3';
export default node;
